import { render, staticRenderFns } from "./ReleaseDetailContainer.vue?vue&type=template&id=768e5112&"
import script from "./ReleaseDetailContainer.vue?vue&type=script&lang=js&"
export * from "./ReleaseDetailContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports